<template>
  <b-container class="my-8">
    <b-row>
      <b-col md="12" class="">
        <span>
          saindo...
        </span>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapActions } from "vuex"
export default {
  data() {
    return {
    }
  },
  methods: {
    ...mapActions('auth', [
      'logoutRequest',
    ]),

    ...mapActions('product', [
      'resetChartsCache',
    ]),
  },
  async mounted() {
    await this.resetChartsCache()
    this.logoutRequest().then(() => {
      localStorage.clear()
      sessionStorage.clear()
      this.$router
        .push({
          path: "/login"
        })
        .catch();
    });

  }
}
</script>
